/**
 * Contains all of the actions that can happen in the App.
 */

import keyMirror from 'keymirror'

export const ROOT_URL = '/myaccount/transfer/fx/fees'
export const PREVIEW_URL = '/myaccount/transfer/fx/fees/send/external/xb?'
export const CHANGE_EVENT = 'CHANGE'

export const ActionTypes = keyMirror({
  REDIRECT_TO_XOOM: null,

  // errors
  SHOW_ERROR_BANNER: null,
  SHOW_ERROR_PAGE: null,

  // xoom interaction stuff
  SET_INITIAL_FLOW_MODEL: null,

  // reset
  RESET_TO_INITIAL: null,
})

export const PayloadSources = {
  SERVER_ACTION: 'SERVER_ACTION',
  VIEW_ACTION: 'VIEW_ACTION',
}
